<!--<div *ngIf="feedDisplay == FeedDisplays.FeedList">
  <app-full-list></app-full-list>
  <div *ngIf="allPosts.length > 0; else loading">
    <div *ngFor="let post of allPosts">
      <ul style="list-style: none;">
        <li><a [routerLink]="['/feed', post.id]">{{post.title.rendered}}</a></li>
      </ul>
    </div>
  </div>
</div>-->
<app-feed-full-list></app-feed-full-list>
